import styled from 'styled-components'


export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60vh;
  width: 100%;
  color: #c0c0c0;
`

export const ErrorCode = styled.h1`

`

export const ErrorMessage = styled.h2`
  font-weight: 500;
`

export const ErrorTip = styled.span`
  cursor: pointer;
  text-decoration: underline;
  font-style: italic;
`

export const HomeButton = styled.button`
  margin-top: 1rem;
  background-color: #0090D3;
  color: #fff;
  border: none;
  border-radius: 3px;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;

  :hover {
    background-color: #0077b6;
  }
`